export const FECHA_DIA_NEGOCIO_TZ = 'America/Argentina/Buenos_Aires';

export function fechaDiaNegocioLocal(date = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: FECHA_DIA_NEGOCIO_TZ }).format(date);
}
